import { render, staticRenderFns } from "./DragPanel.vue?vue&type=template&id=fe5918c2&scoped=true"
import script from "./DragPanel.vue?vue&type=script&lang=js"
export * from "./DragPanel.vue?vue&type=script&lang=js"
import style0 from "./DragPanel.vue?vue&type=style&index=0&id=fe5918c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5918c2",
  null
  
)

export default component.exports